<template>
    <div>
        <p v-if="error" style="color:red;">{{ errorMessage }}</p> 
        <v-btn-toggle v-model="toggle_colors" dark>
            <div v-for="(item, index) in colorlist" :key="index">
                <v-btn :color="item.hex" @click="setUserSettings(item.colorname)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</v-btn>
            </div>
        </v-btn-toggle>
    </div>
</template>
<script>

//FUTURE UPDATES - utilize colors.js/API, must separate color to background image

import userApi from '@/api/user.js'
import colorlist from '@/common/color_themes'
import { updateMobileSystemBar } from '@/helpers/system-panel-settings'

export default {
    data() {
        return {
            error: false,
            errorMessage: '', 
            default_color: 'blue.darken3',
            toggle_colors: null
        }
    },
    methods: {
        setUserSettings(color) {
            if (this.$store.state.color!=color) {
                this.$store.commit('setColor', color)

                const activeColorItem = colorlist.find(item => 
                    item.colorname == color
                );

                if (activeColorItem) {
                    this.$vuetify.theme.primary = activeColorItem.color
                    
                    // REUSABLE HELPER CALL: Synchronize system panel with loaded preferences
                    updateMobileSystemBar(activeColorItem.hex)
                }
                
                this.$emit('send',color.replace('.darken1','').replace('.darken2','').replace('.darken3','').replace('.darken4',''))
                this.saveSettings()
            }
         },
         async saveSettings() {
            this.error = false
            try{
                const data = {
                        "email":  this.$store.state.email, 
                        "color": this.$store.state.color, 
                        "theme": this.$store.state.theme
                        }
                await userApi.updateTheme(data);
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
         },
         initializeSettings() {
            var ctr = 0;
            colorlist.forEach(item => {
                if (item.hex == this.$store.state.color || item.colorname == this.$store.state.color) {
                    this.toggle_colors = ctr
                }
                ctr+=1;
            });
           
            if (this.$store.state.theme=='dark') this.toggle_theme = 0
            else this.toggle_theme = 1
        }
    },
    created() {
        this.colorlist = colorlist
        this.error = false
        this.initializeSettings()    
    },
    computed: {},
    beforeDestroy() {
    }
}
</script>
